module.exports = __webpack_public_path__ + "static/media/bottle_purple_1.2ec3cb45.png";